module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/1-e48064d74398d10fb30e3290ee90ea12.svg";